import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { Col, Form, Skeleton , Row, Select, Typography, Space, Button, Flex } from 'antd';
import {getById, } from '../../../../apis/MovimientoEmpleadoApi';
import {getList as getPeriodos, getDetailsById as getDetailsByPeriodId} from '../../../../apis/PeriodosApi';
import {getEmpleadosByPeriodoNomina} from '../../../../apis/OdooApi';
import {getByConfiguration} from '../../../../apis/AcomuladoApi';
import Currency from '../../../../components/common/Currency';
import useCookies from "../../../../hooks/useCookies";
import _ from 'lodash';
const { Text, Link } = Typography;

const { Option } = Select;
const App = forwardRef(function AnioPeriodo({onOk, onChangeEmpleado, onCancel, header, form, object, values, disabledForm, disabledSubmit = false}, ref) {
    const [empleadoCookie, setEmpleadoCookie] = useCookies("empleado_id");
    const [ID, setID] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const [disabled, setDisabled] = useState(disabledForm ?? false);
    const [initialValues, setInitialValues] = useState(values);
    const [empleados, setEmpleados] = useState([]);
    const [empleado, setEmpleado] = useState([]);
    const [tipoPeriodoSelected, setTiposPeriodoSelected] = useState([]);
    const [percepciones, setPercepciones] = useState(0);
    const [neto, setNeto] = useState(0);
    const [deducciones, setDeducciones] = useState(0);
    const [despensa, setDespensa] = useState(0);
    const [detailsPeriodo, setDetailsPeriodo] = useState([]);
    //1- Sustituir 2- Sumar 3- No Sustituir, Default 1
    const [clases, setClases] = useState([
        {value: "1", text:'Sustituir'},
        {value: "2", text:'Sumar'},
        {value: "3", text:'No Sustituir'},
    ]);
    const conceptoRef = React.createRef();
    const effectRan = useRef(false);
    useEffect(() => {
        (async () => {
            if(!header){return;}
            if(header?.periodo_id > 0){
                await getEmpleadosOdoo(header.periodo_id);
            }

            var _initialValues = {...header};
            if(header?.period_id > 0){
                _initialValues.period_id = header.period_id;
            }
            if(header?.num_periodo > 0){
                _initialValues.num_periodo = header.num_periodo;
            }
            if(header?.anio > 0){
                _initialValues.anio = header.anio;
            }
            if(header?.odoo_empleado_id > 0 ){
                _initialValues.odoo_empleado_id = header.odoo_empleado_id;
            }else if(empleadoCookie){
                _initialValues.odoo_empleado_id = empleadoCookie.value;
            }
            form.setFieldsValue(_initialValues);
        })();
    }, [header]);

    useEffect(() => {
        (async () => {
            if(object?.id > 0){
                setID(object.id);
                await refreshData(object.id);
            }
        })();
    }, [object]);

    useEffect(() => {
        (async () => {
            if(tipoPeriodoSelected?.value > 0){
                await getDetailsPeriodo(tipoPeriodoSelected.value);                    
            }
        })();
    }, [tipoPeriodoSelected]);

    useEffect(() => {
        (async () => {
            setDisabled(disabledForm)
        })();
    }, [disabledForm]);

    useEffect(() => {
        (async () => {
            if(!header){return;}

            var _initialValues = {...header};
            if(header?.period_id > 0){
                _initialValues.period_id = header.period_id;
            }
            if(header?.num_periodo > 0){
                _initialValues.num_periodo = header.num_periodo;
            }
            if(header?.anio > 0){
                _initialValues.anio = header.anio;
            }
            if(header?.odoo_empleado_id > 0){
                _initialValues.odoo_empleado_id = header.odoo_empleado_id;
                await onChangeEmpleadoSelect(header.odoo_empleado_id)
            }else if(empleadoCookie){
                _initialValues.odoo_empleado_id = empleadoCookie.value;
                await onChangeEmpleadoSelect(empleadoCookie.value)
            }
            form.setFieldsValue(_initialValues);
        })();
    }, [empleados]);

    const refreshData = async (id)=> {
        const response = await getById(id);
        if(response.ok){
            let item = response.payload;
            setInitialValues(item);
            form.setFieldsValue(item);
        }
    }

    const getEmpleadosOdoo = async (period_id)=>{
        const response = await getEmpleadosByPeriodoNomina(period_id, header?.anio, header?.num_periodo, 'procesar');
        if(response.ok){
            let items = response.payload;
            setEmpleados(items);
            if(header?.odoo_empleado_id > 0 || empleadoCookie){
                await onChangeEmpleado(empleadoCookie);
            }
        }
    }

    const getDetailsPeriodo = async (id)=>{
        let detailsResponse = await getDetailsByPeriodId(id);
        if(detailsResponse.ok){
            let item = detailsResponse.payload;
            setDetailsPeriodo(item);
        }
    }

    const onReset = () => {
        form.resetFields();
    };

    const onCancelBtn = async ({}) => {
        if(onCancel){
            await onCancel();
        }
    }

    const actualizarAcumulados = async (empleadoId) => {
        let responseAcumulados = await getByConfiguration(empleadoId, header?.periodo_id, header?.anio, header?.num_periodo);
        if(responseAcumulados.ok){
            let list = responseAcumulados.payload.list;
            let configuration = responseAcumulados.payload.configuration;
            let _percepciones = list.find(x=>x.acumulado?.id > 0 && x.concepto.id == configuration.concepto_percepcion_total);
            let _deducciones = list.find(x=>x.acumulado?.id > 0 && x.concepto.id == configuration.concepto_deducción_total);
            let _neto = list.find(x=>x.acumulado?.id > 0 && x.concepto.id == configuration.concepto_total_neto);
            let _despensa = list.find(x=>x.concepto?.concepto_sat == "029" && x.concepto?.tipo_concepto?.clase == "4");

            setPercepciones(_percepciones?.monto);
            setDeducciones((-1)*_deducciones?.monto);
            setNeto(_neto?.monto);
            setDespensa(_despensa?.monto);
        }
    }

    const onFinish = async ()=> {
        setLoading(true);
        var values = form.getFieldsValue();
        await onOk(values);
        // Refrescar los acumulados después de procesar
        if(values.odoo_empleado_id){
            await actualizarAcumulados(values.odoo_empleado_id);
        }
        setLoading(false);
    }

    const onChangeEmpleadoSelect = async (value)=>{
        const empleado = empleados.find(x=>x.value == value)
        setEmpleado(empleado);
        setEmpleadoCookie(empleado);
        await onChangeEmpleado(value);
        await actualizarAcumulados(value);
    }

    const filterOption = (input, option) => {
        return (option?.children ?? '').toLowerCase().includes(input.toLowerCase());
    };

    return (
        <>
            <Form disabled={disabled}
                layout="vertical" 
                form={form} 
                requiredMark 
                autoComplete="off"
                onFinish={onFinish}>
                <Row gutter={16}>
                    <Col md={{span: 8}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="odoo_empleado_id"
                            label="Empleado"
                            rules={[
                            {
                                required: true,
                                message: 'Selecciona un empleado',
                            },
                            ]}
                        >
                            <Select 
                                placeholder="Por favor selecciona un empleado" 
                                onChange={onChangeEmpleadoSelect}
                                showSearch 
                                optionFilterProp="children"
                                filterOption={filterOption}
                                allowClear
                            >
                                {
                                    empleados.map((item)=><Option key={item.value} value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    {
                        empleado && 
                        <Col md={{span: 16}} sm={{span: 16}} xs={{span: 24}}>
                            <Row>
                                <Space size={'middle'}>
                                    <Text keyboard>Salario Diario <b><Currency value={empleado.nomina_daily_salary} /></b></Text>
                                    <Text keyboard>Salario Integrado <b><Currency value={empleado.nomina_integrated_salary} /></b></Text>
                                    <Text keyboard>Horario <b>{empleado.resource_calendar_name}</b></Text>
                                </Space>
                            </Row>
                            <Row>
                                <Space size={'middle'}>
                                    <Text keyboard>Registro Patronal <b>{empleado.nomina_employer_registration_key}</b></Text>
                                    <Text keyboard>Fecha de Ingreso <b>{empleado.nomina_entry_date}</b></Text>
                                    {
                                        empleado.nomina_leaving_date && <Text keyboard>Fecha de Baja <b>{empleado.nomina_leaving_date}</b></Text>
                                    }
                                    
                                </Space>
                            </Row>
                            <Row style={{paddingTop: 10}}>
                                <Col md={{span: 8}} sm={{span: 12}} xs={{span: 24}}>Percepciones <br/><b><Currency value={percepciones}/></b></Col>
                                <Col md={{span: 8}} sm={{span: 12}} xs={{span: 24}}>Deducciones <br/><b><Currency value={deducciones}/></b></Col>
                                <Col md={{span: 8}} sm={{span: 12}} xs={{span: 24}}>Neto <br/><b><Currency value={neto}/></b></Col>
                                {despensa > 0 && <Col md={{span: 8}} sm={{span: 12}} xs={{span: 24}}>Vale de Despensa <br/><b><Currency value={despensa}/></b></Col>}
                            </Row>
                        </Col>
                    }
                </Row>
                <Form.Item>
                    <Space>
                        <Button type="primary" htmlType="submit" loading={loading} disabled={disabledSubmit}>
                            {loading ? 'Procesando': 'Procesar'}
                        </Button>
                        <Button htmlType="button" onClick={onReset}>
                            Limpiar
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </>
    );
});

export default App;